import { app } from 'src/app'
import variables from './variables.js'

function getNestedObject (object, key) {
  if (object[key]) {
    return object[key]
  }
  else {
    const paths = key.split('.')
    let toReturn = object[paths[0]]

    for (let i = 1; i < paths.length; i++) {
      if (toReturn[paths[i]]) {
        toReturn = toReturn[paths[i]]
      }
      else {
        break
      }
    }

    return toReturn
  }
}

export default {
  deltaTransformPoint (matrix, point) {
    const dx = point.x * matrix.a + point.y * matrix.c
    const dy = point.x * matrix.b + point.y * matrix.d
    return { x: dx, y: dy }
  },
  decomposeMatrix (matrix) {
    // @see https://gist.github.com/2052247

    // calculate delta transform point
    const px = this.deltaTransformPoint(matrix, { x: 0, y: 1 })
    const py = this.deltaTransformPoint(matrix, { x: 1, y: 0 })

    // calculate skew
    const skewX = ((180 / Math.PI) * Math.atan2(px.y, px.x) - 90)
    const skewY = ((180 / Math.PI) * Math.atan2(py.y, py.x))

    return {
      translateX: matrix.e,
      translateY: matrix.f,
      scaleX: Math.sqrt(matrix.a * matrix.a + matrix.b * matrix.b),
      scaleY: Math.sqrt(matrix.c * matrix.c + matrix.d * matrix.d),
      skewX: skewX,
      skewY: skewY,
      rotation: skewX // rotation is the same as skew x
    }
  },
  variableListTranslate (item) {
    return app.$i18n.t(item.value)
  },
  getVariableTranslation (item) {
    if (item?.translated?.length && item.translated[app.$i18n.locale]) {
      return item.translated[app.$i18n.locale].value
    }
    else if (item) {
      return item.value
    }
    else {
      return ''
    }
  },
  /**
   * Used to get the translated value of variables for ag grid
   * @param params
   * @returns {*}
   */
  translationGetter (params) {
    const data = getNestedObject(params.data, params.colDef.field)

    if (data?.translated?.length && data.translated[params.context.parent.$i18n.locale]) {
      return data.translated[params.context.parent.$i18n.locale].value
    }
    else if (data) {
      return data.value
    }
    else {
      return 'no value'
    }
  },
  excludeVariables: variables.excludeVariables,
  variableList: variables.variableList,
  pluralMap: variables.pluralMap,
  pathMap: variables.pathMap
}
